import { Tracer } from "./core";

/**
 * 导出所有类型定义和接口
 */
export * from "./index.interface";

/**
 * 导出 Tracer 类，用于创建自定义实例
 */
export { Tracer };

/**
 * 默认导出的 Tracer 实例，可直接使用
 *
 * @example
 * ```typescript
 * import Insight from '@credit/insight-sdk'
 *
 * Insight.init({ region: 'id', bizType: 'spl' })
 * Insight.reportClickEvent('btn-submit')
 * ```
 */
const Insight = new Tracer();
export default Insight;
